<template>
  <div class="w-full h-full flex overflow-auto">
    <div class="w-full max-h-full px-4">
      <div class="flex flex-col bg-white pt-4 z-50">
        <div class="flex">
          <div class="flex w-full justify-start mb-4">
            <h1-styled :colorP="colorP">Galería</h1-styled>
          </div>
        </div>
      </div>

      <!-- Gallery -->
      <div class="w-full">
        <nav class="text-sm flex justify-start">
          <link-tab-styled
            @click="mediaType = 'Imagenes'"
            class="inline-block px-4 py-2"
            v-bind:class="[
              mediaType === 'Imagenes'
                ? 'border-b-2 tab-active font-semibold'
                : 'text-gray-700 hover:text-black',
            ]"
            href="#"
            :colorT="colorT"
            >Imágenes</link-tab-styled
          >
          <link-tab-styled
            @click="mediaType = 'Videos'"
            class="inline-block px-4 py-2"
            v-bind:class="[
              mediaType === 'Videos'
                ? 'border-b-2 tab-active font-semibold'
                : 'text-gray-700 hover:text-black',
            ]"
            href="#"
            :colorT="colorT"
            >Videos</link-tab-styled
          >
        </nav>
      </div>

      <div
        v-show="mediaType === 'Imagenes'"
        class="grid gap-2 lg:gap-4 grid-cols-2 lg:grid-cols-5 z-50 pb-4"
      >
        <template v-for="(register, index) in multimedia">
          <div
            v-if="register.mimeType.includes('image')"
            class="border-2 shadow-md rounded flex flex-col justify-center items-center"
            :key="'galleryMm' + index"
          >
            <span-styled
              class="py-2 text-sm font-bold tracking-wide"
              :colorS="colorS"
            >
              {{ register.nombre }}
            </span-styled>
            <v-lazy-image
              :src="replaceURL(register.fileName, 'img')"
              class="rounded object-contain"
              style="width: 250px; height: 250px"
              @error="loadDefaultImg"
            />
            <div class="flex flex-col py-2">
              <span-styled class="text-sm" :colorS="colorS">
                {{ register.nombre_usuario }} {{ register.apellido_usuario }}
              </span-styled>
              <span class="text-gray-500 text-xs">
                {{ register.TDate }}
              </span>
            </div>
            <div class="pb-2">
              <!-- <button
                @click="zoomOnMap(register)"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
              >
                Ver en mapa
              </button> -->
              <link-styled
                :href="replaceURLMapByLevantamiento(register)"
                target="_blank"
                class="px-4 py-2 text-white rounded text-sm"
                :colorT="colorT"
                >Ver en mapa</link-styled
              >
            </div>
          </div>
        </template>
      </div>

      <div
        v-show="mediaType === 'Videos'"
        class="grid gap-2 lg:gap-4 grid-cols-2 lg:grid-cols-5 z-50 pb-4"
      >
        <template v-for="(register, index) in multimedia">
          <div
            v-if="register.mimeType.includes('video')"
            class="border-2 shadow-md rounded flex flex-col justify-center items-center"
            :key="'galleryMm' + index"
          >
            <span-styled
              class="py-2 text-sm font-bold tracking-wide"
              :colorS="colorS"
            >
              {{ register.nombre }}
            </span-styled>
            <video
              :src="replaceURL(register.fileName, 'video')"
              class="rounded object-contain"
              style="width: 250px; height: 250px"
              controls
            ></video>
            <div class="flex flex-col py-2">
              <span-styled class="text-sm" :colorS="colorS">
                {{ register.nombre_usuario }} {{ register.apellido_usuario }}
              </span-styled>
              <span class="text-gray-500 text-xs">
                {{ register.TDate }}
              </span>
            </div>
            <div class="pb-2">
              <!-- <button
                @click="zoomOnMap(register)"
                class="px-4 py-2 bg-primary-color text-white rounded text-sm"
              >
                Ver en mapa
              </button> -->
              <link-styled
                :href="replaceURLMapByLevantamiento(register)"
                class="px-4 py-2 text-white rounded text-sm"
                :colorT="colorT"
                >Ver en mapa</link-styled
              >
            </div>
          </div>
        </template>
      </div>
      <!-- Gallery -->
    </div>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin";

import { styled } from "@egoist/vue-emotion";


const LinkTabStyled = styled("a")`
  &.tab-active {
    color: ${(props) => props.colorT};
    border-color: ${(props) => props.colorT};
  }
`;

const H1Styled = styled("h1")`
  color: ${(props) => props.colorP};
  font-weight: bold;
  font-size: 1.75rem;
`;

const SpanStyled = styled("span")`
  color: ${(props) => props.colorS};
`;

const LinkStyled = styled("a")`
  background-color: ${(props) => props.colorT};
`;

export default {
  mixins: [urlMixin],
  name: "gallery-grid",
  data() {
    return {
      mediaType: "Imagenes",
      showingMultimedia: false,
      currentMultimedia: {},
    };
  },
  props: {
    multimedia: {
      required: true,
    },
    colorP: {
      required: true,
    },
    colorS: {
      required: true,
    },
    colorT: {
      required: true,
    },
  },
  components: { LinkTabStyled, H1Styled, SpanStyled, LinkStyled },
  methods: {

    loadDefaultImg(event) {
      event.target.src = "@/assets/default-image-sm.jpg";
    },
    replaceURLMapByLevantamiento(register) {
      return `../compartir/${btoa(register.id)}`;
    },
  },
};
</script>
